// NotAuthorized.js
import React from 'react';

const NotAuthorized = () => {
  return (
    <div className="flex items-center justify-center h-screen">
      <h1 className="text-3xl font-bold">403 - Not Authorized</h1>
    </div>
  );
};

export default NotAuthorized;
